import React from "react";

interface IconProps {
  className?: string;
  fill?: string;
  stroke?: string;
}

export const EyeIcon: React.FC<IconProps> = ({
  className = "w-5 h-5",
  fill = "none",
  stroke = "currentColor",
}) => (
  <svg className={className} fill={fill} stroke={stroke} viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
    />
  </svg>
);

export const EyeOffIcon: React.FC<IconProps> = ({
  className = "w-5 h-5",
  fill = "none",
  stroke = "currentColor",
}) => (
  <svg className={className} fill={fill} stroke={stroke} viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
    />
  </svg>
);

export const PlusIcon: React.FC<IconProps> = ({
  className = "w-5 h-5",
  fill = "none",
  stroke = "currentColor",
}) => (
  <svg className={className} fill={fill} stroke={stroke} viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 4v16m8-8H4"
    />
  </svg>
);

export const XIcon: React.FC<IconProps> = ({
  className = "w-5 h-5",
  fill = "none",
  stroke = "currentColor",
}) => (
  <svg className={className} fill={fill} stroke={stroke} viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
);

export const TrashIcon: React.FC<IconProps> = ({
  className = "w-5 h-5",
  fill = "none",
  stroke = "currentColor",
}) => (
  <svg className={className} fill={fill} stroke={stroke} viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
    />
  </svg>
);

export const CheckIcon: React.FC<IconProps> = ({
  className = "w-5 h-5",
  fill = "none",
  stroke = "currentColor",
}) => (
  <svg className={className} fill={fill} stroke={stroke} viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5 13l4 4L19 7"
    />
  </svg>
);

export const ChevronDownIcon: React.FC<IconProps> = ({
  className = "w-5 h-5",
  fill = "none",
  stroke = "currentColor",
}) => (
  <svg className={className} fill={fill} stroke={stroke} viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 9l-7 7-7-7"
    />
  </svg>
);

export const ChevronUpIcon: React.FC<IconProps> = ({
  className = "w-5 h-5",
  fill = "none",
  stroke = "currentColor",
}) => (
  <svg className={className} fill={fill} stroke={stroke} viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5 15l7-7 7 7"
    />
  </svg>
);

export const LoadingSpinner: React.FC<IconProps> = ({
  className = "w-5 h-5",
  stroke = "currentColor",
}) => (
  <svg
    className={`animate-spin ${className}`}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke={stroke}
      strokeWidth="4"
    />
    <path
      className="opacity-75"
      fill={stroke}
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    />
  </svg>
);

